import { useContext } from 'react';
import { DropdownField, ProductDetailsContext } from '@components';
import { useAuth } from '@hooks';
import { formatPrice } from '@utils/price.utils';
import { Box } from '@mui/material';

export const ProductVariantSelector = () => {
  const { product = {} } = useContext(ProductDetailsContext);
  const { isAuthenticated } = useAuth();

  // Variant list
  const variantList =
    product?.variants?.map((x) => ({
      value: x?.expanded?.contentLink?.id?.toString() || '',
      label: x?.expanded?.displayName + ' - ' + formatPrice(x.expanded?.grossPrice),
      action: () => x?.url,
    })) || [];
  const selectedVariant = variantList[0]?.label || '';

  return isAuthenticated && variantList.length > 0 ? (
    <Box sx={{ pt: 4 }}>
      <DropdownField
        fullWidth
        value={selectedVariant}
        label={`Variants (${variantList?.length}):`}
        options={variantList}
      />
    </Box>
  ) : null;
};
